import Vue from "vue";
import firebase from "firebase/app";
import "firebase/database";

const state = {
  donations: {}
};

const getters = {
  donationList: (state) => (filter) => {
    if (filter !== "none") {
      return Object.values(state.donations).filter(donation => donation.status === filter)
    }
    return Object.values(state.donations);
  }
};

// Donation section
const mutations = {
  loadDonations(state, payload) {
    state.donations = payload;
  },

  deleteDonation(state, payload) {
    Vue.delete(state.donations, payload.key);
  }
};

const actions = {
  deleteDonation({ commit }, payload) {
    firebase
      .database()
      .ref("data/donations/" + payload.key)
      .set(null, error => {
        if (error) {
          // The write failed...
          commit("showMessage", {
            type: "error",
            message: "Error deleting Donation, Try again!"
          });
          console.log(error);
        } else {
          commit("showMessage", { message: "Donation deleted successfully!" });
          commit("deleteDonation", payload);
        }
      });
  }
};

export default { state, getters, actions, mutations };



// WEBPACK FOOTER //
// ./src/store/donations.js